const KEY = '_p_list';

const save = list => {
    localStorage.setItem(KEY, JSON.stringify(list));
};

export const getAllProducts = () => {
    try {
        return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
        return [];
    }
};

export const addProduct = (id, title, picture) => {
    const list = getAllProducts();
    const item = list.find(x => x.id === id);

    if (item) {
        item.quantity += 1;
    } else {
        list.push({ id, title, picture, quantity: 1 });
    }

    save(list);
};

export const updateProduct = (id, quantity) => {
    const list = getAllProducts().map(x =>
        x.id === id ? { ...x, quantity: Math.max(1, quantity) } : x
    );

    save(list);
};

export const removeProduct = id => {
    save(getAllProducts().filter(x => x.id !== id));
};

export const clearList = () => {
    localStorage.removeItem(KEY);
};

export const getTotalQuantity = () =>
    getAllProducts().reduce((sum, i) => sum + i.quantity, 0);
